/** "deposit issue" → "Deposit Issue", "open" → "Open" */
export function formatDisplayLabel(value) {
  if (value == null || value === "") return "";
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
